<template>
  <div>
    <PageAllow controller="OrderMaterialAnalyze" action="orderService" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="overflow-y-scroll fill-content-height">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 导出 -->
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="exportExcel()"
              >
                <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                {{ $t("orderService.Export.excel") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 订单编码 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="order_code"
                    v-model="options.order_code"
                    @text="codeKeyword = $event"
                    :label="$t('orderService.Fields.order_code')"
                  />
                </v-col>
                <!-- 客户 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherShops v-model="shopsSelected" />
                </v-col>
                <!-- 分组 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherDistrictsWithDescendants
                    v-model="DistrictsSelected"
                    :label="
                      $t('shopDailyReports.shopDistricts', [$consts.shopName()])
                    "
                  />
                </v-col>
                <!-- 状态 -->
                <v-spacer />
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.status"
                    :label="$t('orderService.status.ObjectName')"
                    :items="$consts.order.status"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="order_freight"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.order_code="{ item }">
              <span class="text-no-wrap caption font-weight-bold">
                {{ item.order_code }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.created | formatTime }}
              </span>
            </template>
            <template v-slot:item.fee="{ item }">
              <span class="text-no-wrap">
                {{ $t("Global.money") }}{{ item.fee | formatMoney }}
              </span>
            </template>
            <template v-slot:item.service_charge="{ item }">
              <span class="text-no-wrap">
                {{ $t("Global.money") }}{{ item.service_charge | formatMoney }}
              </span>
            </template>
            <template v-slot:item.sub_account_freight="{ item }">
              <span class="text-no-wrap">
                {{ $t("Global.money")
                }}{{ item.sub_account_freight | formatMoney }}
              </span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                small
                outlined
                color="info"
                class="px-2 me-2"
                :href="
                  '/#/order-service/' + item.bill_code
                "
              >
                <v-icon x-small class="pe-1">fa-align-left</v-icon>
                {{ $t("Opt.details") }}
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import OrderService from "@/api/order_service";
import SearcherShops from "@/components/plugins/SearcherShops";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import Shops from "@/api/shops";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  actual_time_from: "",
  actual_time_to: "",
  shop_ids: [],
  district_ids: [],
  status: [1, 2, 3, 4, 5, 6],
};

export default {
  data: () => ({
    order_freight: [],
    paging: {},
    options: JSON.parse(JSON.stringify(defaultOptions)),
    loading: false,
    shopsSelected: null,
    DistrictsSelected: [],
    codeKeyword: "",
  }),
  components: {
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    PageAllow,
    SearcherShops,
    SearcherStatus,
    SearcherDistrictsWithDescendants,
    SearcherKeyword,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("orderService.ObjectName"),
        disabled: true,
      },
    ],
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("orderService.Fields.created_date"),
      },
      {
        key: "actual",
        text: i18n.t("orderService.Fields.actual_time"),
      },
    ],
    headers() {
      let headers = [
        // 订单编码
        {
          text: i18n.t("orderService.Fields.order_code") +
            " / " +
            i18n.t("orderService.Fields.created"),
          align: "start",
          sortable: false,
          value: "order_code",
        },
        // 门店名称
        {
          text: i18n.t("orderService.Fields.shop_name"),
          align: "center",
          sortable: false,
          value: "shop_name",
        },
        // 分组
        {
          text: i18n.t("orderService.Fields.district_name"),
          align: "center",
          sortable: false,
          value: "district_name",
        },
        // 订单总毛重
        {
          text: i18n.t("orderService.Fields.gross_weight_total"),
          align: "center",
          sortable: false,
          value: "gross_weight_total",
        },
        // 账单金额
        {
          text: i18n.t("orderService.Fields.fee"),
          align: "center",
          sortable: false,
          value: "fee",
        },
        // 订单运费
        {
          text: i18n.t("orderService.Fields.service_charge"),
          align: "center",
          sortable: false,
          value: "service_charge",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];

      return headers;
    },
    ...mapState(["settings"]),
  },

  mounted() {
    if (this.$route.query.dateType) {
      this.options = JSON.parse(JSON.stringify(defaultOptions))
        if (this.$route.query.dateType == 'today') {
          this.options.created_time_from = new Date(new Date().getTime()).toISOString().substr(0, 10) + " 00:00:00";
          this.options.created_time_to =  new Date().toISOString().substr(0, 10) + " 23:59:59";
        }
        if (this.$route.query.dateType == 'yesterday') {
          this.options.created_time_from = new Date(new Date().getTime() - 1 * 24 * 3600 * 1000).toISOString().substr(0, 10) + " 00:00:00";
          this.options.created_time_to =  new Date(new Date().getTime() - 1 * 24 * 3600 * 1000).toISOString().substr(0, 10) + " 23:59:59";
        }
      sessionStorage.setItem(
          "order-material-service-options",
          JSON.stringify(this.options)
      );
    }
    this.getShopFromAPI();
    // this.$store.commit("districtID", 0);
    this.$store.commit("searchDistrict", false);
    this.$commonUtils
      .loadOptions("order-material-service", [
        "shopsSelected",
        "DistrictsSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "shopsSelected":
                this.shopsSelected = selected.value;
                break;
              case "DistrictsSelected":
                this.DistrictsSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign(this.options, {
        order_code: this.codeKeyword,
      });
      this.getOrderServiceFromAPI();
    },
    resetSearch() {
      this.shopsSelected = [];
      this.DistrictsSelected = [];

      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getOrderServiceFromAPI() {
      this.loading = true;
      OrderService.fetch(Object.assign({}, this.options, {})).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.order_freight = response.data.orders;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    exportExcel() {
      OrderService.exports(Object.assign({}, this.options, {}));
    },

    getShopFromAPI() {
      if (this.$route.query.shop_id) {
        Shops.fetchOne(this.$route.query.shop_id).then(
          function (response) {
            if (response.data.status.isOK()) {
              var shop = response.data.shop;
              this.shopsSelected = [shop];
            }
          }.bind(this)
        );
      }
    },
  },
  watch: {
    // districtID: {
    //   handler() {
    //     this.getOrderServiceFromAPI();
    //   },
    // },
    options: {
      deep: true,
      handler() {
        this.getOrderServiceFromAPI();
        sessionStorage.setItem(
          "order-material-service-options",
          JSON.stringify(this.options)
        );
      },
    },
    // 门店
    shopsSelected: {
      handler() {
        this.options.shop_ids = this.shopsSelected
          ? this.shopsSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "order-material-service-shopsSelected",
          JSON.stringify(this.shopsSelected)
        );
      },
    },
    DistrictsSelected: {
      handler() {
        this.options.district_ids = this.DistrictsSelected
          ? this.DistrictsSelected.map((e) => {
              return e.id;
            })
          : [];
        sessionStorage.setItem(
          "order-material-service-DistrictsSelected",
          JSON.stringify(this.DistrictsSelected)
        );
      },
    },
  },
};
</script>

<style>
</style>